<template>
    <div class="siteList">
        <div class="siteName">
            站点列表
        </div>
        <div class="list">
            <div class="concent">
                <el-tree :data="data" :props="defaultProps" empty-text="暂无数据" accordion node-key="id" @node-click="handleNodeClick">
                    <span slot-scope="{data}" class="spanLine" >
                        <img class="icon" :src="data.src" alt=""> 
                        {{data.label}}
                    </span>
                </el-tree>
            </div>
        </div>
    </div> 
</template>

<script>
export default {
    data(){
        return {
            data: [],
            list:[
                {
                    id:'1',
                    src:require('../assets/img/siteLi.png'),
                    label: '变配电站',
                    children:[]
                }, 
                {   
                    id:'2',
                    src:require('../assets/img/pvli.png'),
                    label: '光伏电站',
                    children: []
                }, 
                {
                    id:'3',
                    src:require('../assets/img/pvli.png'),
                    label: '储能电站',
                    children: []
                },
                {
                    id:'4',
                    src:require('../assets/img/pvli.png'),
                    label: '充电站',
                    children: []
                }, 
            ],
            defaultProps: {
                children: 'children',
                label: 'label'
            }
        }
    },
    mounted(){
        this.getArea()

    },
    methods:{
        handleNodeClick(data) {
            this.$emit('send',data)
        },
        // 获取项目站点分类
        getArea(){
            let areas = this.$store.state.areas
            console.log(areas);
            let norSite = []
            let guaSite = []
            let diaSite = []
            let choSite = []

            areas.forEach(item =>{
                let obj = {  
                    id:item.areaId,
                    label: item.areaName,
                }
                if(item.areaType == 0 || item.areaType == 1){
                    norSite.push(obj)
                }else if(item.areaType == 2){
                    guaSite.push(obj)
                }else if(item.areaType == 3){
                    diaSite.push(obj)
                }
            })
            this.$set(this.list[0],'children', norSite)
            this.$set(this.list[1],'children', guaSite)
            this.$set(this.list[2],'children', diaSite)

            this.list.forEach(item =>{
                if(item.children.length > 0){
                    this.data.push(item)
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .siteList{
        position: absolute;
        width: 304rem;
        max-height: 325rem;
        left: 10rem;
        top: 80rem;
        box-shadow: 0 0 10rem 2rem rgba(13, 148, 255, 0.5);
        
        .siteName{
            width: 100%;
            height: 36rem;
            line-height: 36rem;
            padding: 0 16rem;
            font-size: 16rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #E6F3FD;
            text-shadow: 0px 0px 4px #031225;
            background: linear-gradient(90deg, rgba(7, 121, 214, 0.8) 0%, rgba(4, 34, 66, 0.7) 100%);
        }

        .list{
            width: 100%;
            max-height: 289rem;
            padding: 10rem 8rem 10rem 0 ;
            background: linear-gradient(90deg, rgba(3,13,24, 0.7) 0%,rgba(23, 54, 121, 0.7) 100% );
            .concent{
                width: 100%;
                max-height: 280rem;
                overflow-x: hidden;
                overflow-y:scroll ;
                .el-tree{
                    width:100%;
                    background: none;    
                    font-family: Microsoft YaHei; 
                    font-weight: 400;
                    color: #E6F3FD;

                    ::v-deep .el-tree-node__content{
                        padding: 0.3vh 0;
                        background: none;
                        padding-left: 8rem !important;
                        opacity: 1;
                        font-size: 16px;
                        .spanLine{
                            font-size: 16px;
                            color: #E6F3FD;
                        }
                    }
                    ::v-deep.el-tree-node__children > .el-tree-node {
                        padding: 0.3vh 0;
                        padding-left: 32rem !important;
                        border: none;
                        .spanLine{
                            font-size: 16px;
                            color: #E6F3FD;
                            opacity: 0.7;
                        }
                        &:hover{
                            background: linear-gradient(90deg, rgba(13, 148, 255, 0.5) 0%, rgba(13, 148, 255, 0) 100%) !important;
                        }
                        &::before{
                            content: "";
                            width: 200px ;
                            height: 1px;
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            background: rgba(13, 148, 255, 0);
                        }
                    }
                    ::v-deep.el-tree-node{
                        padding: 0.3vh 0;
                        background: none;
                        position: relative;

                        &::before{
                            content: "";
                            width: 300rem ;
                            height: 1px;
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            background: linear-gradient(90deg, rgba(13, 148, 255, 0.5) 0%, rgba(13, 148, 255, 0) 100%);
                        }
                    }
                    ::v-deep.el-tree-node.is-current > .el-tree-node__content {
                        background: none !important;
                    }
                    ::v-deep .el-icon-caret-right:before{     // 未展开
                        content: "";
                        font-size: 18px;

                    }
                    ::v-deep .expanded:before{     // 展开
                        content:"";
                        font-size: 18px;
                    }

                    
                }

                .spanLine{
                    width: 100%;
                    display: block;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    text-shadow: 0px 0px 4px #031225;
                    height:30px ;
                    line-height: 30px;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                }
            }
            .concent::-webkit-scrollbar{
                width:4rem;
            }
            .concent::-webkit-scrollbar-thumb{
                color: #fff;
                background-color: #fff;
                border-radius: 2rem;
            }
        }
    }

</style>